import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import StyledTag from 'talent_matching/components/shared/styled_tag';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { withLocalePrefix } from 'shared/utils/translation';
import { RediscoveryAction } from 'talent_matching/types';

const t = withLocalePrefix(
  'talent_matching.rediscovery.table.rediscovery_activity_cell'
);

const actionText = (action: RediscoveryAction): string => {
  if (action.action === 'sent_email') {
    return t('sent_email');
  }

  return t('added_as_prospect');
};

export const ActionsList = ({
  actions,
  direction = 'column',
  spacing = 0.5,
}: {
  actions: RediscoveryAction[];
  direction?: 'row' | 'column';
  spacing?: number;
}) => {
  return (
    <Stack spacing={spacing} direction={direction}>
      {actions.map((action: RediscoveryAction) => {
        return (
          <StyledTag
            key={action.id}
            text={actionText(action)}
            bgColor={FullPalette.IRIS_E50}
          />
        );
      })}
    </Stack>
  );
};

const RediscoveryActivityCell = ({
  applicationId,
}: {
  applicationId: number;
}) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  const rediscoveryActions = application.rediscoveryActions;
  const hasActions = rediscoveryActions.length > 0;

  return (
    <Stack
      spacing={0.5}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      {hasActions ? (
        <ActionsList actions={rediscoveryActions} />
      ) : (
        <StyledTag
          text={t('no_actions')}
          bgColor={'unset'}
          fontColor={FullPalette.GREY_800}
        />
      )}
    </Stack>
  );
};

export default RediscoveryActivityCell;
